import React from 'react';
import { motion } from 'framer-motion';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  onClick?: () => void;
}
export function GlassCard({
  children,
  className = '',
  hoverEffect = false,
  onClick
}: GlassCardProps) {
  return <motion.div onClick={onClick} className={`
        relative overflow-hidden rounded-2xl 
        bg-white/5 backdrop-blur-xl 
        border border-white/10 
        shadow-xl shadow-black/20
        ${className}
      `} data-id="element-738">
      {/* Gradient glow effect on hover/active */}
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 via-purple-500/5 to-pink-500/5 opacity-0 transition-opacity duration-500 hover:opacity-100 pointer-events-none" data-id="element-739" />

      {/* Content */}
      <div className="relative z-10 h-full" data-id="element-740">{children}</div>
    </motion.div>;
}